import { urlWithParams } from 'libs/utils/url';
export const USER_PERSONALIZATION_SIZES_URL = '/member/personalization/sizes';
export const USER_PERSONALIZATION_SIZES_CATEGORY_URL = type => "/member/personalization/sizes/".concat(type);
export const USER_PERSONALIZATION_BRANDS_URL = '/member/personalization/brands';
export const USER_PERSONALIZATION_BRANDS_FOLLOWED_URL = '/member/personalization/brands/followed';
export const MEMBER_PROFILE_URL = (id, collection) => urlWithParams("/member/".concat(id), {
  collection
});
export const MEMBER_ITEMS_URL = id => "/member/".concat(id, "/items");
export const MEMBER_RESTORE_URL = id => "/admin/users/".concat(id, "/restore");
export const MEMBER_SEARCH_URL = (page, searchText) => "/member/general/search?page=".concat(page, "&search_text=").concat(searchText);
export const MEMBER_FOLLOW_URL = (id, tab, page) => urlWithParams("/member/general/follow/".concat(id), {
  tab,
  page
});
export const MEMBER_FOLLOWING_URL = (id, page) => page ? "/member/general/following/".concat(id, "?page=").concat(page) : "/member/general/following/".concat(id);
export const MEMBER_FOLLOWERS_URL = (id, page) => page ? "/member/general/followers/".concat(id, "?page=").concat(page) : "/member/general/followers/".concat(id);
export const MEMBER_TEMPLATES_URL = id => "/admin/member/".concat(id, "/user_msg_templates");
export const MEMBER_SATISFACTION_SURVEY_URL = userId => "/member/".concat(userId, "/satisfaction_survey/new");
export const ITEM_UPLOAD_URL = '/items/new';
export const ITEM_URL = id => "/items/".concat(id);
export const ITEM_ID_SLUG_URL = slug => "/items/".concat(slug);
export const EDIT_ITEM_URL = id => "/items/".concat(id, "/edit");
export const EDIT_ITEM_URL_WITH_ANCHOR = (id, anchor) => "/items/".concat(id, "/edit#").concat(anchor);
export const PROFILE_SETTINGS_URL = '/settings/profile';
export const ACCOUNT_SETTINGS_URL = '/settings/account';
export const DONATIONS_SETTINGS_URL = '/settings/donations';
export const SHIPPING_SETTINGS_URL = '/settings/shipping';
export const BUNDLE_DISCOUNT_SETTINGS_URL = '/settings/bundle_discount';
export const PRIVACY_SETTINGS_URL = '/settings/privacy';
export const POLICIES_SETTINGS_URL = '/settings/policies';
export const CREATE_BUNDLE_URL = id => "/member/".concat(id, "/bundles/new");
export const FEATURED_COLLECTION_URL = '/items/featured_collections';
export const EDIT_FEATURED_COLLECTION_URL = id => "/items/featured_collections/".concat(id);
export const CATALOG_URL = '/catalog';
export const CATALOG_ID_URL = id => "/catalog/".concat(id);
export const VERIFY_EMAIL_URL = '/settings/account/send_email_confirmation';
export const MARK_AS_SOLD_URL = transactionId => " /transactions/".concat(transactionId, "/mark_as_sold/new?act_as=sold");
export const MARK_ITEM_AS_RESERVED_URL = itemId => "/member/items/reservation?id=".concat(itemId);
export const MARK_ITEM_AS_SOLD_URL = itemId => "/member/items/close?act_as=sold&id=".concat(itemId);
export const BUY_URL = (transactionId, sourceScreen) => "/transaction/buy/new?transaction_id=".concat(transactionId, "&source_screen=").concat(sourceScreen);
export const TRANSACTION_COMPLETED_URL = transactionId => "/transaction/completed/payment_close?transaction_id=".concat(transactionId);
export const CHECKOUT_URL = transactionId => "/checkout?transaction_id=".concat(transactionId);
export const SINGLE_CHECKOUT_URL = (orderId, purchaseType) => "/checkout?id=".concat(orderId, "&type=").concat(purchaseType);
export const SUBSCRIPTION_SETTINGS_URL = '/settings/subscriptions';
export const EMAIL_CHANGE_OLD_URL = '/users/verification/email/new';
export const EMAIL_CHANGE_CONFIRM_URL = '/member/settings/email/confirm';
export const RESEND_EMAIL_CONFIRMATION = refUrl => "/member/signup/resend_confirmation?ref_url=".concat(refUrl);
export const FORGOT_PASSWORD_URL = '/member/general/forgot_password';
export const LOGIN = '/member/general/login';
export const ROOT_URL = '/';
export const BRANDS_URL = '/brands';
export const BRANDS_BY_LETTER_URL = letter => "/brands/by_letter/".concat(letter);
export const TERMS_URL = '/terms_and_conditions';
export const TERMS_AGREE_URL = '/terms_and_conditions/agree';
export const IMPRESSUM_URL = '/impressum';
export const BUSINESS_TERMS_URL = '/pro-terms-of-use';
export const PRIVATE_BETA_TERMS_URL = '/private-beta-terms-of-use';
export const PHONE_VERIFICATION_URL = '/users/verification/phone/new';
export const CHANGE_PHONE_URL = '/users/verification/phone/edit';
export const OUR_PLATFORM_URL = '/our-platform';
export const ADMIN_CATALOG_ITEM_URL = '/admin/catalog_items';
export const GO_TO_WALLET_URL = '/wallet/balance';
export const MY_ORDERS_URL = function () {
  let {
    type,
    status,
    page
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    type: 'all'
  };
  return urlWithParams("/my_orders/".concat(type), {
    status,
    page
  });
};
export const MY_ORDERS_SOLD_URL = '/my_orders/sold';
export const MY_ORDERS_PURCHASED_URL = '/my_orders/purchased';
export const WALLET_ACCOUNT_EDIT_URL = '/wallet/bank_account';
export const SHIPPING_INSTRUCTIONS_URL = transactionId => "/member/instructions/shipment?transaction_id=".concat(transactionId);
export const TRANSACTION_FAQ_ENTRY_URL = transactionId => "/help/for_transaction/".concat(transactionId);
export const COMPLAINT_URL = complaintId => "/complaints/".concat(complaintId);
export const LEAVE_FEEDBACK_URL = userId => "/member/".concat(userId, "/feedback/new");
export const EDIT_FEEDBACK_URL = (userId, feedbackId) => "/member/".concat(userId, "/feedback/").concat(feedbackId, "/edit");
export const FEEDBACK_URL = (userId, feedbackId) => "/member/".concat(userId, "/feedback/").concat(feedbackId);
export const APP_LANDING_URL = '/app';
export const OFFER_REQUEST_ACCEPT_URL = (transactionId, offerRequestId) => "/transactions/".concat(transactionId, "/offer_requests/").concat(offerRequestId, "/accept");
export const OFFER_REQUEST_REJECT_URL = (transactionId, offerRequestId) => "/transactions/".concat(transactionId, "/offer_requests/").concat(offerRequestId, "/reject");
export const SECURITY_SETTINGS_URL = '/settings/security';
export const WALLET_SETUP_URL = '/wallet/setup';
export const WALLET_PAYOUT_URL = '/wallet/payouts/new';
export const BUMP_MULTIPLE_ITEM_SELECTION_URL = '/items/push_up/new';
export const PAYMENTS_IDENTITY = '/settings/payments_identity';
export const MERGE_PORTAL_LANDING_URL = '/merge';
export const MERGE_PORTAL_CONSENT_URL = '/merge/consent';
export const DELETE_ACCOUNT_URL = '/delete_account';
export const MEMBER_DELETE_ACCOUNT_URL = '/member/general/delete_account';
export const MEMBER_DELETE_ACCOUNT_SUCCESS_URL = '/member/general/delete_account_success';
export const SIGNUP_URL = '/member/signup/select_type';
export const REGISTER_URL = '/member/signup/email_start';
export const CHANGE_PASSWORD = '/member/general/change_password';
export const CODE_LOGIN = _ref => {
  let {
    refUrl,
    authProps: {
      control_code,
      next_resend_available_in,
      user_masked_info,
      show_resend_option
    }
  } = _ref;
  return urlWithParams('/member/general/code_login', {
    ref_url: refUrl,
    control_code,
    next_resend_available_in,
    user_masked_info,
    show_resend_option: show_resend_option || null
  });
};
export const USER_SEARCH_URL = '/member/general/search';
export const USER_FAVOURITE_ITEMS_URL = '/member/items/favourite_list';
export const PAYOUT_DETAILS = function (payoutId) {
  let showSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return "/wallet/payouts/".concat(payoutId).concat(showSuccess ? '?success=true' : '');
};
export const NEW_ADMIN_ALERT_URL = '/admin_alert/new';
export const HELP_FAQ_ENTRIES_URL = '/help';
export const SIGNUP_HELP_ENTRIES_URL = '/help/103';
export const GUIDE_ENTRIES_URL = '/help/360';
export const NOTIFICATIONS_URL = '/member/notifications';
export const NEW_HELP_TICKET_URL = '/help/support_tickets/new';
export const FORUM_POST_EDIT_URL = postId => "/forum/post_edit?id=".concat(postId);
export const NEW_FORUM_TOPIC_URL = (forumId, subforumId) => subforumId ? "/forum/topic_new?forum_id=".concat(forumId, "&sub_forum_id=").concat(subforumId) : "/forum/topic_new?forum_id=".concat(forumId);
export const TOPIC_URL_WITH_POST = (topicUrl, postId) => "".concat(topicUrl, "?post_id=").concat(postId);
export const TOPIC_URL_PAGINATED = (topicUrl, page) => "".concat(topicUrl, "?page=").concat(page);
export const FORUM_HOME_URL = '/forum';
export const PRICELIST_URL = '/pricelist';
export const FORUM_NEWEST_TOPICS_URL = '/forum/newest';
export const FORUM_OWN_TOPICS_URL = '/forum/own_topics';
export const FORUM_FAVOURITE_TOPICS_URL = '/forum/favourite_topics';
export const FORUM_EDIT_TOPIC_URL = '/forum/topic_edit';
export const FORUM_SEARCH_URL = '/forum/search';
export const PAYMENTS_SETTINGS_URL = '/settings/payments';
export const TWO_FACTOR_AUTH_URL = '/users/verification/user_2fa';
export const PRIVACY_POLICY_URL = '/privacy-policy';
export const COOKIE_POLICY_URL = '/cookie-policy';
export const BUYER_PROTECTION_URL = '/safety#buyer-protection';
export const BUYER_PROTECTION_PRO_URL = '/safety_pro#buyer-protection';
export const BUSINESS_TERMS_OF_SALE_URL = '/pro-terms-of-sale';
export const INCOME_REPORT_URL = year => "/wallet/income_reports/".concat(year, ".pdf");
export const YEARLY_INCOME_REPORT_URL = year => "/wallet/income_reports/".concat(year, ".pdf");
export const MONTHLY_INCOME_REPORT_URL = (year, month) => "/wallet/income_reports/".concat(year, "/").concat(month, ".pdf");
export const INVOICE_URL = invoiceId => "/wallet/invoices/".concat(invoiceId);
export const REFERRALS_URL = '/referrals';
export const REFERRALS_REGISTRATIONS_URL = '/referrals/registrations';
export const REQUEST_DATA_EXPORT_URL = '/request_data_export';
export const KYC_HELP_URL = '/help/111';
export const SELLING_HELP_URL = '/help/52';
export const REPORT_HELP_URL = '/help/288';
export const SERVICE_FEE_HELP_URL = '/help/342';
export const SERVICE_FEE_PRO_HELP_URL = '/help/908';
export const BUSINESS_ACCOUNTS_HOMEPAGE = '/pro';
export const BUSINESS_ACCOUNTS_GUIDE_URL = '/pro-guide';
export const INTELLECTUAL_PROPERTY_INFRINGEMENT = '/help/intellectual_property_infringement';
export const INTELLECTUAL_PROPERTY_INFRINGEMENT_REPORT = "".concat(INTELLECTUAL_PROPERTY_INFRINGEMENT, "/report");
export const NOTICE_AND_ACTION_FORM = '/help/notice_and_action_form';
export const NOTICE_AND_ACTION_FORM_REPORT = "".concat(NOTICE_AND_ACTION_FORM, "/report");
export const MAIN_NAVIGATION_ABOUT_TAB_URL = '/about';
export const DONATION_CLOSE_URL = '/donations/close';
export const SOCIAL_FACEBOOK_URL = 'https://www.facebook.com/vinted';
export const SOCIAL_LINKEDIN_URL = 'https://www.linkedin.com/company/vinted';
export const SOCIAL_INSTAGRAM_URL = 'https://www.instagram.com/vinted';
export const HELP_CENTER_URL = '/help';
export const HELP_SELLING_URL = '/help/4-selling?access_channel=hc_topics';
export const HELP_BUYING_URL = '/help/5-buying?access_channel=hc_topics';
export const HELP_TRUST_SAFETY_URL = '/help/15-trust-safety';
export const HELP_REFUND_POLICY = '/help/465-the-vinted-refund-policy';
export const HELP_SAFETY_URL = '/safety';
export const HELP_SEARCH_URL = '/help/s';
export const BUNDLES_POLICY_URL = '/help/260';
export const EMAIL_VERIFICATION_URL = '/users/verification/email/new';
export const HOW_IT_WORKS_URL = '/how_it_works';
export const INFOBOARD_URL = '/infoboard';
export const ITEM_VERIFICATION_URL = '/item_verification';
export const SUSTAINABILITY_URL = '/sustainability';
export const PRESS_URL = '/presse';
export const ADVERTISING_URL = '/advertising';
export const JOBS_URL_NEW = 'https://careers.vinted.com/';
export const JOBS_URL = '/jobs';
export const SECURITY_SETTINGS_2FA_URL = '/settings/security/phone_verification';
export const SECURITY_SETTINGS_AUTHENTICATION_URL = '/settings/security/authentication';
export const WALLET_INVOICES_URL = '/wallet/invoices';
export const PRESS_CENTER_URL = 'https://company.vinted.com';
export const USER_SESSIONS_URL = '/settings/security/sessions';
export const USERS_VERIFICATION_URL = '/users/verification';
export const EMAIL_CODE_VERIFICATION_URL = '/users/verification/email_code';
export const GOOGLE_OAUTH_URL = '/auth/google/oauth';
export const GO_TO_TAXPAYER_FORM_URL = '/settings/taxpayer';
export const WALLET_HISTORY_PATH = '/wallet/history';
export const HAOV_VERIFICATION_GENERAL_URL = '/help/1147';
export const APP_STORE_BY_DEVICE_URL = 'https://4uwb.adj.st/?adjust_t=l2fpdc8_rnxf4nj';
export const APP_FEEDBACKS_URL = '/app_feedbacks';
export const VAS_GALLERY_ITEM_SELECTION_URL = '/items/vas_gallery/new';
export const APPLE_APP_STORE_URL = 'https://itunes.apple.com/fr/app/vinted.fr/id632064380?mt=8';
export const ANDROID_APP_STORE_URL = 'https://play.google.com/store/apps/details?id=fr.vinted';
export const WALLET_HISTORY_OVERVIEW_URL = '/wallet/history/overview';
export const WALLET_INCOME_REPORTS_URL = '/wallet/income_reports';
export const MEMBER_RESET_PASSWORD = '/member/general/reset_password';
export const BUSINESS_ACCOUNT_REGISTER_URL = '/pro/register';
export const BLOCKED_URL = '/main/blocked';
export const BANNED_URL = '/main/banned';
export const BALANCE_ACTIVATION_URL = '/member/balance_activation';
export const FULL_NAME_CONFIRMATION_URL = '/member/full_name_confirmation';
export const COMPLAINT_MORE_INFORMATION_URL = complaintId => "/complaints/".concat(complaintId, "/faq_entry");
export const ADMIN_SECTION_ITEM_PAGE_URL = itemId => "/admin/item_moderation_actions/".concat(itemId);
export const ADMIN_SECTION_PROFILE_PAGE_URL = userId => "/admin/member/".concat(userId);
export const DSA_APPEAL_EDUCATION_URL = threadId => "/dsa/appeal_education?thread_id=".concat(threadId);
export const DSA_NOTICE_APPEAL_URL = threadId => "/dsa/notice_appeal?thread_id=".concat(threadId);
export const TAX_RULES_URL = '/settings/tax_rules';
export const TAX_PAYER_URL = '/settings/taxpayer';
export const COLLECTIONS_MANAGEMENT_URL = '/items/collections_management';
export const RECOMMENDED_BROWSERS_URL = '/recommended_browsers';
export const DAC7_URL = '/dac';
export const TAXPAYER_EDUCATION_URL = '/settings/taxpayer_education';